import { useState } from "react";
import {
  ReservationInfoPanel,
  ReservationConfirmation,
  ReservationForm
} from "../components/reservation/ReservationParts";

function ReservationHero() {
  return (
    <section
      className="relative h-[45vh] min-h-[360px] flex items-center justify-center text-center bg-cover bg-center"
      style={{
        backgroundImage:
          "linear-gradient(rgba(10,36,36,0.72), rgba(10,36,36,0.88)), url(/image/siteimages/gallery/pexels-photo-2387675.jpg)"
      }}
    >
      <div className="relative pt-20">
        <span className="divider-ornament text-spice-gold">Book a Table</span>
        <h1 className="font-display text-white text-5xl md:text-6xl lg:text-7xl font-medium mt-5">
          Reservations
        </h1>
      </div>
    </section>
  );
}

export default function Reservations() {
  const [confirmation, setConfirmation] = useState(null);

  const handleSuccess = (form, date) => setConfirmation({ form, date });
  const handleReset = () => setConfirmation(null);

  if (confirmation) {
    return (
      <ReservationConfirmation
        form={confirmation.form}
        date={confirmation.date}
        onReset={handleReset}
      />
    );
  }

  return (
    <>
      <ReservationHero />
      <section className="py-20 lg:py-28 bg-cream">
        <div className="max-w-5xl mx-auto px-5 lg:px-10 grid lg:grid-cols-5 gap-12">
          <ReservationInfoPanel />
          <ReservationForm onSuccess={handleSuccess} />
        </div>
      </section>
    </>
  );
}
